module.exports = __webpack_public_path__ + "static/c_ssu-08f637cde134f3b0c51d9a41f3bec40f.jpg";